import {string} from 'prop-types';
import {Controller} from 'react-hook-form';

import {controlPropType, fieldPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';
import TextInput from '../field-components/TextInput/TextInput';

const TextFieldRenderer = ({control, field, prefix, error, helperText}) => {
  console.log({control, field});
  return (
    <>
      <FieldLabel required={field.required}>{field.label}</FieldLabel>
      <Controller
        name={buildFieldName(field, prefix)}
        control={control}
        render={({field: rhfField}) => <TextInput error={error} helperText={helperText} {...rhfField} placeholder={field.placeholder} />}
      />
    </>
  );
};

TextFieldRenderer.propTypes = {
  control: controlPropType.isRequired,
  field: fieldPropType.isRequired,
  prefix: string,
  error: string,
  helperText: string
};

export default TextFieldRenderer;
